import React from 'react';
import styles from './AcfForm.module.scss';
import className from 'classnames/bind';
import { gql } from '@apollo/client';
import { WordPressBlocksViewer } from '@faustwp/blocks';
import { Form } from '@/components';

let cx = className.bind(styles);

export default function AcfForm(props) {
	const { attributes, innerBlocks, form, id} = props;
	const formType = form.formType[0];
	const className = attributes.className?.split(' ') || [];

	function InnerBlocks() {
		return React.createElement(WordPressBlocksViewer, { blocks: innerBlocks !== null && innerBlocks !== void 0 ? innerBlocks : [] });
	}
	return (
		<Form className={cx([attributes.alignForm && `align-${attributes.alignForm}`, ...className])} method={formType === 'Basic' ? form.basicFormSettings?.method : 'POST'} action={formType === 'Basic' ? form.basicFormSettings?.action : null} emailSettings={formType === 'Email' && form.emailSettings} formType={formType} id={attributes.anchor || `form-${id}`} successMessage={form.successMessage}>
			<InnerBlocks />
		</Form>
	);
}

AcfForm.fragments = {
	key: `AcfFormFragment`,
	entry: gql`
		fragment AcfFormFragment on AcfForm {
			attributes {
				anchor
				className
				alignForm: align
			}
			form {
				formType
				basicFormSettings {
					method
					action
				}
				emailSettings {
					subject
					to
					body
				}
        successMessage
			}
		}
	`,
};

AcfForm.config = {
	name: 'AcfForm',
};
AcfForm.displayName = 'AcfForm';
